import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(() => ({
  container: {
    height: "100%"
  },
  line: {
    flexGrow: 1
  }
}));
